import { BankConfig } from '../Model/BankConfig';
import { storeApi } from './storeApi';

export const bankConfigApi = storeApi.injectEndpoints({
  endpoints: (builder) => ({
    getBankConfigs: builder.query<BankConfig[], void>({
      query: () => '/bankConfigs',
    }),
  }),
});

export const { useLazyGetBankConfigsQuery } = bankConfigApi;
